<div class="preview-container animate-in fade-in slide-in-from-bottom-4 duration-500">
  <!-- Icon -->
  <div
    class="w-20 h-20 mx-auto mb-6 rounded-full flex items-center justify-center"
    [style.background-color]="themeColor + '20'"
  >
    <lucide-icon
      [img]="icons.BookOpen"
      class="w-10 h-10"
      [style.color]="themeColor"
    ></lucide-icon>
  </div>

  <!-- Title -->
  <h1 class="text-2xl font-bold text-gray-900 text-center mb-2">
    {{ preview?.subject || 'Assignment' }}
  </h1>

  <!-- Subtitle -->
  <p class="text-gray-500 text-center mb-8 max-w-sm mx-auto">
    Your teacher has assigned you a new quiz. Review the details below and tap
    start when you're ready. Good luck!
  </p>

  <!-- Info Cards -->
  <div
    class="info-cards mb-8 rounded-2xl border border-gray-100 bg-white shadow-sm overflow-hidden divide-y divide-gray-100"
  >
    <!-- Questions count -->
    <div class="flex items-center gap-3 px-4 py-3">
      <div
        class="w-9 h-9 rounded-lg flex items-center justify-center shrink-0"
        [style.background-color]="themeColor + '14'"
      >
        <lucide-icon
          [img]="icons.FileText"
          class="w-[18px] h-[18px]"
          [style.color]="themeColor"
        ></lucide-icon>
      </div>
      <span class="text-sm text-gray-500">Questions</span>
      <span class="ml-auto text-sm font-semibold text-gray-900">
        {{ preview?.questionCount || 0 }}
      </span>
    </div>

    <!-- Time limit -->
    @if (preview?.timeLimit !== undefined && preview?.timeLimit !== null) {
      <div class="flex items-center gap-3 px-4 py-3">
        <div
          class="w-9 h-9 rounded-lg flex items-center justify-center shrink-0"
          [style.background-color]="themeColor + '14'"
        >
          <lucide-icon
            [img]="icons.Clock"
            class="w-[18px] h-[18px]"
            [style.color]="themeColor"
          ></lucide-icon>
        </div>
        <span class="text-sm text-gray-500">Time limit</span>
        <span class="ml-auto text-sm font-semibold text-gray-900">
          {{ formatTimeLimit(preview!.timeLimit!) }}
        </span>
      </div>
    }

    <!-- Due date -->
    <div class="flex items-center gap-3 px-4 py-3">
      <div
        class="w-9 h-9 rounded-lg flex items-center justify-center shrink-0"
        [style.background-color]="themeColor + '14'"
      >
        <lucide-icon
          [img]="icons.Calendar"
          class="w-[18px] h-[18px]"
          [style.color]="themeColor"
        ></lucide-icon>
      </div>
      <span class="text-sm text-gray-500">Due date</span>
      <span class="ml-auto text-sm font-semibold text-gray-900">
        {{ preview?.dueDate ? (preview!.dueDate | date: 'MMM d, y') : 'No due date' }}
      </span>
    </div>
  </div>

  <!-- Start Button -->
  <button
    type="button"
    (click)="onStart()"
    [disabled]="isLoading"
    class="w-full py-4 px-6 rounded-xl font-semibold text-white text-lg flex items-center justify-center gap-2 transition-all duration-200 hover:opacity-90 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed shadow-lg"
    [style.background-color]="themeColor"
  >
    @if (isLoading) {
      <div
        class="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"
      ></div>
      <span>Loading...</span>
    } @else {
      <span>Start Assignment</span>
      <lucide-icon [img]="icons.ArrowRight" class="w-5 h-5"></lucide-icon>
    }
  </button>
</div>
